import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { RootState } from '../../modules';
import { getListVarsAsync, getListInfoAsync, editContent } from '../../modules/editor';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { getPathAfterBuild } from '../../util/file';
import { isAllowedFieldForMailMerge } from '../../util/mailMerge';
import Alert from '../../lib/Alert';

type Props = {
	target: string;
	value: string
};

function MergeDropDown({ target, value }: Props) {
	const dispatch = useDispatch();

	const [open, setOpen] = useState(false);
	const [listInfoFields, setListInfoFields] = useState([] as any);

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const email = useSelector((state: RootState) => state.editor.email);
	const listVars = useSelector((state: RootState) => state.editor.listVars);
	const listInfo = useSelector((state: RootState) => state.editor.listInfo);
	const accountPlan = useSelector((state: RootState) => state.auth.account.billing.plan);
	const msg = useSelector((state: RootState) => state.editor.service.msg);
  const hasNoList = email.listId === -1 || email.listId === undefined || email.isListDeleted;

	const _listVars = useMemo(() => {
		return listVars.filter(isAllowedFieldForMailMerge);
	}, [listVars]);

	useEffect(() => {
		setListInfoFields([
			{ label: '회사/단체명', value: listInfo.companyName},
			{ label: '주소', value: listInfo.companyAddress},
			{ label: '연락처', value: listInfo.companyContact},
		]);
	}, [listInfo])

	const toggleOpen = () => {
		if (!isStandard) {
			openUpgradeGuideModal();
			return;
		}
		if (hasNoList) {
			Alert.error(msg.CHECK_SELECT_LISTS);
			return;
		}
		setOpen(!open);
		dispatch(getListVarsAsync.request());
		dispatch(getListInfoAsync.request());
	}

	const getResultText = (text:string) => {		
		let pos:number = window.getSelection()?.getRangeAt(0)?.startOffset || 0;
		return `${value.substring(0, pos)}${text}${value.substring(pos, value.length)}`;
	}

	const insertInfo = (item:any) => {
		const newValue:string = getResultText(item.value);
		applyText(newValue);
	}
	
	const insertMergeTag = (item: any) => {
		let mt = `$%${item.substitution}%$`;
		const newValue:string = getResultText(mt);
		applyText(newValue);
	}

	const applyText = (value:string) => {
		dispatch(editContent({ target: target, data: value }));
		setOpen(false);
	}

	const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		setOpen(false);
	});

	const openUpgradeGuideModal = () => {
		window.parent.postMessage({ msg: 'openUpgradeGuideModal', guideType: 'mailMerge' }, '*');
	};

	const isStandard = accountPlan >= 2;
	return (
		<div className="merge-dropdown" ref={ref}>
			<button 
				className={open ? 'btn active' : 'btn'}
				onClick={toggleOpen}
			>
				<ReactSVG src={iconImage(`./icon/toolbar/merge.svg`)} width="10" />
			</button>
			{
				open && (
					<div className="merge-dropdown-body">
						<h2>주소록 필드</h2>
						<ul>
							{
								listInfoFields.map((item: any, index: number) => (
									<li key={index}>
										<button onClick={() => { insertInfo(item);}} >{item.label} </button>
									</li>
								))
							}
						</ul>
						<h2>사용자 정의 필드</h2>
						<ul>
							{
								_listVars.map((item:any, index:number) => (
									<li key={index}>
										<button onClick={() => { insertMergeTag(item); }}>{item.label} <small>{item.substitution}</small></button>
									</li>
								))
							}
						</ul>
					</div>
				)
			}
		</div>
	);
}

export default MergeDropDown;